import {useEffect, useState} from 'react';
import {
    GetIdentityValidationType,
    GetValidationId
} from '../../../../../reduxToolkit/Visitor/VisitorApi';
import {useNavigate, useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import { IDENTITY_VALIDATION_TYPE_MODEL } from '../../Visitor/Model/Model';
import routes from '../../../../../Routes/routes';
import {setSelectedDocumentType} from '../../../../../reduxToolkit/Visitor/VisitorSlice';
import {useDispatch, useSelector} from 'react-redux';
import {GetInvitationById} from '../../../../../reduxToolkit/Invitation/InvitationApi';
import {getUrlParameters} from "../Model/Model";
import {getMainUrl} from "../../../../Veridas/Model/Models";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ChooseValidationTypeApp = () => {
    const { id, guardFlowId, userId, eventId, buildingId } = useParams();
    const backUrl = buildingId
        ? getMainUrl({ userId, buildingId })
        : eventId
            ? getUrlParameters({ url: `${routes.eventDetails.findMySelf}${eventId}`})
            : getUrlParameters({ url: routes.invitationDetails.identityValidation, id, guardFlowId });

    const nextUrlVeridas = buildingId
        ? getUrlParameters({ url: `${routes.buildingRegistration.documentPage}${userId}/${buildingId}` })
        : eventId
            ? getUrlParameters({ url: `${routes.eventDetails.documentPage}${userId}/${eventId}` })
            : getUrlParameters({ url: routes.veridasIntegration.documentPage, id, guardFlowId });

    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { getInvitationById } = useSelector((state) => state.InvitationSlice);
    const { getIdentityValidationType } = useSelector((state) => state.VisitorSlice);
    const [selectedList, setSelectedList] = useState([]);

    useEffect(() => {
        dispatch(GetValidationId());
        dispatch(GetIdentityValidationType());
    }, []);

    useEffect(() => {
        if (id && (!getInvitationById || getInvitationById?.length <= 0)) {
            dispatch(GetInvitationById(id));
        }
    }, [id]);

    const getUrl = () => {
        if (selectedList.length === 0) {
            toast.warn(t("you_must_select_an_option"));
            return null;
        }
        const isAutomatic = IDENTITY_VALIDATION_TYPE_MODEL.VERIDAS.id ===  getIdentityValidationType;
        const selectionType = selectedList[0].type;
        const documentType = selectedList[0].id;
        if(isAutomatic){//Only event id and userId
            dispatch(setSelectedDocumentType(selectedList[0]));
            navigate(nextUrlVeridas);
        } else navigate(getUrlParameters({ url: routes.invitationDetails.createExternal + selectionType + "/" + documentType + "/", id, guardFlowId }))
    }

    return {
        t,
        navigate,
        id,
        guardFlowId,
        selectedList,
        setSelectedList,
        getUrl,
        getInvitationById,
        getIdentityValidationType,
        backUrl
    }
}

export default ChooseValidationTypeApp
